import { render, staticRenderFns } from "./FootSection.vue?vue&type=template&id=6dd6a091"
import script from "./FootSection.vue?vue&type=script&lang=js"
export * from "./FootSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports